import { Box, Text } from '@chakra-ui/react';
import { RouterLink } from '@gamma/ui/navigation';
import { ROUTES } from '@investigator/shared/constants';
import { useDateRangeQueryString } from '@investigator/shared/hooks';
import { i18n } from '@investigator/shared/localization';
import { SeverityScore } from '@investigator/shared/components';
import { stringifyAlertType } from '@investigator/shared/utils';
import {
  AlertInfo,
  DetectionRank,
} from '@investigator/shared/generated/graphql';

import { DetailsGrid, DetailsGridRow } from '..';

export interface DetectionDetailsGridProps {
  alert_info: AlertInfo;
  rank: DetectionRank;
}

export const DetectionDetailsGrid = ({
  alert_info,
  rank,
}: DetectionDetailsGridProps) => {
  const { start, end } = useDateRangeQueryString();

  const { detection } = i18n.pages.detections;

  const { type, severity, alertCategory } = detection;

  const { systemSettingsAlertCatalog } = ROUTES;

  return (
    <DetailsGrid>
      {alert_info?.alert_name && (
        <DetailsGridRow
          data-testid="detection-alert-name"
          title={alertCategory}
        >
          <Box
            __css={{
              wordWrap: 'anywhere',
              _hover: { textDecoration: 'underline' },
            }}
          >
            <RouterLink
              color="text.link"
              __css={{
                wordWrap: 'anywhere',
              }}
              data-testid="pivot-detection-alert-catalog-link"
              to={`${systemSettingsAlertCatalog(
                `/${alert_info?.content_id}?start=${start}&end=${end}`,
              )}`}
            >
              {alert_info?.alert_name}
            </RouterLink>
          </Box>
        </DetailsGridRow>
      )}
      {rank?.severity !== null && rank?.severity !== undefined && (
        <DetailsGridRow
          data-testid="detection-alert-severity-score"
          title={severity}
        >
          <SeverityScore score={rank.severity} />
        </DetailsGridRow>
      )}
      {alert_info?.alert_type && (
        <DetailsGridRow title={type} data-testid="detection-type">
          <Text>{stringifyAlertType(alert_info?.alert_type)}</Text>
        </DetailsGridRow>
      )}
    </DetailsGrid>
  );
};
